// Layouts
import TrangChu from "layouts/trang-chu";
import GiaoDichCuaToi from "layouts/giao-dich-cua-toi";
import ChonChuVuon from "layouts/thu-mua/ChonChuVuon";
import ChonVuon from "layouts/thu-mua/ChonVuon";
import FormThuMua from "layouts/thu-mua/FormThuMua";
import XacNhanThanhToan from "layouts/thu-mua/XacNhanThanhToan";
import ChiTietSot from "layouts/sot/ChiTietSot";
import ChiTietChuVuon from "layouts/chu-vuon/ChiTietChuVuon";
import QuanLyChuVuonVuon from "layouts/quan-ly-chu-vuon-vuon";
import ChoDuyetChuVuonVuon from "layouts/cho-duyet-chu-vuon-vuon";
import QuanLyHopTacXa from "layouts/quan-ly-hop-tac-xa";
import QuanLySot from "layouts/quan-ly-sot";
import NhapXuatKho from "layouts/kho/NhapXuatKho";
import LichSuKho from "layouts/kho/LichSuKho";
import DanhMuc from "layouts/danh-muc";
import GiaTheoNgay from "layouts/gia-theo-ngay";
import BaoCao from "layouts/bao-cao";
import ChungTuThuMua from "layouts/chung-tu-thu-mua";
import HangChoThanhToan from "layouts/hang-cho-thanh-toan";
import ChiTietHangChoThanhToan from "layouts/hang-cho-thanh-toan/ChiTiet";
import QuanLyTaiKhoan from "layouts/quan-ly-tai-khoan";
import CaiDat from "layouts/cai-dat";
import HoSo from "layouts/ho-so";
import HuongDan from "layouts/huong-dan";
import { BAT_HUONG_DAN } from "lib/batHuongDan";

// @mui icons
import Icon from "@mui/material/Icon";

// roles: undefined = ai đăng nhập cũng thấy/vào được. Có mảng thì chỉ vai trò
// trong danh sách mới thấy trên Sidenav và truy cập được route.
const VAI_TRO_THU_MUA = ["nhan_vien", "admin"];
const VAI_TRO_QUAN_LY = ["admin"];
// Chờ duyệt CV/Vườn + chi tiết 1 chủ vườn: admin + NV (không gồm list-all QL).
const VAI_TRO_CHU_VUON_VUON = ["admin", "nhan_vien"];
const VAI_TRO_BAO_CAO = ["admin", "ke_toan", "ban_giam_doc"];
// Hàng chờ thanh toán: chỉ kế toán + admin (không BGD) — khớp API contract.
const VAI_TRO_HANG_CHO_THANH_TOAN = ["ke_toan", "admin"];
const VAI_TRO_KHO = ["kho", "admin"];
// Ban giám đốc chỉ được vào 1 mục trong nhóm "Quản lý": "Loại bơ & Giá" —
// trang này CRUD cả loaiBo lẫn giaTheoNgay (xem layouts/gia-theo-ngay). Trang
// "Danh mục" thực ra quản lý hinhThucThanhToan (không phải loaiBo) nên KHÔNG
// nằm trong yêu cầu "sét loại bơ và thêm giá bơ" — vẫn chỉ admin. Các mục
// Quản lý còn lại cũng vẫn chỉ admin.
const VAI_TRO_DANH_MUC_GIA = ["admin", "ban_giam_doc"];
// Divider/title của một section được lọc phẳng theo `roles` giống mọi mục khác
// (App.js: sidebarRoutes.filter((r) => !r.roles || r.roles.includes(vaiTro))),
// nên roles của header phải là HỢP các roles của mục con bên dưới nó — nếu không
// vai trò chỉ thấy một phần mục con sẽ mất luôn tiêu đề section.
// Không gộp VAI_TRO_CHU_VUON_VUON: NV không vào section Quản lý chỉ vì Chờ duyệt
// (Chờ duyệt nằm dưới Thu mua) hay vì chi tiết 1 chủ vườn (hidden route).
const VAI_TRO_HEADER_QUAN_LY = [...new Set([...VAI_TRO_QUAN_LY, ...VAI_TRO_DANH_MUC_GIA])];

// Các mục hiện trên Sidenav.
const sidebarRoutes = [
  { type: "title", title: "Thu mua", key: "title-thu-mua" },
  {
    type: "collapse",
    name: "Trang chủ",
    key: "trang-chu",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/",
    component: <TrangChu />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Thu mua",
    key: "thu-mua",
    icon: <Icon fontSize="small">storefront</Icon>,
    route: "/thu-mua/chu-vuon",
    component: <ChonChuVuon />,
    noCollapse: true,
    roles: VAI_TRO_THU_MUA,
  },
  {
    type: "collapse",
    name: "Giao dịch của tôi",
    key: "giao-dich-cua-toi",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/giao-dich-cua-toi",
    component: <GiaoDichCuaToi />,
    noCollapse: true,
    roles: VAI_TRO_THU_MUA,
  },
  {
    type: "collapse",
    name: "Chờ duyệt CV/Vườn",
    key: "cho-duyet-chu-vuon-vuon",
    icon: <Icon fontSize="small">fact_check</Icon>,
    route: "/cho-duyet/chu-vuon-vuon",
    component: <ChoDuyetChuVuonVuon />,
    noCollapse: true,
    roles: VAI_TRO_CHU_VUON_VUON,
  },
  { type: "divider", key: "divider-kho", roles: VAI_TRO_KHO },
  { type: "title", title: "Kho", key: "title-kho", roles: VAI_TRO_KHO },
  {
    type: "collapse",
    name: "Nhập/Xuất kho Sọt",
    key: "kho-nhap-xuat-sot",
    icon: <Icon fontSize="small">swap_horiz</Icon>,
    route: "/kho/nhap-xuat-sot",
    component: <NhapXuatKho />,
    noCollapse: true,
    roles: VAI_TRO_KHO,
  },
  {
    type: "collapse",
    name: "Lịch sử nhập/xuất kho",
    key: "kho-lich-su",
    icon: <Icon fontSize="small">history</Icon>,
    route: "/kho/lich-su",
    component: <LichSuKho />,
    noCollapse: true,
    roles: VAI_TRO_KHO,
  },
  { type: "divider", key: "divider-bao-cao", roles: VAI_TRO_BAO_CAO },
  { type: "title", title: "Báo cáo", key: "title-bao-cao", roles: VAI_TRO_BAO_CAO },
  {
    type: "collapse",
    name: "Báo cáo",
    key: "quan-ly-bao-cao",
    icon: <Icon fontSize="small">bar_chart</Icon>,
    route: "/quan-ly/bao-cao",
    component: <BaoCao />,
    noCollapse: true,
    roles: VAI_TRO_BAO_CAO,
  },
  {
    type: "collapse",
    name: "Chứng từ thu mua",
    key: "chung-tu-thu-mua",
    icon: <Icon fontSize="small">description</Icon>,
    route: "/quan-ly/chung-tu-thu-mua",
    component: <ChungTuThuMua />,
    noCollapse: true,
    roles: VAI_TRO_BAO_CAO,
  },
  {
    type: "collapse",
    name: "Hàng chờ thanh toán",
    key: "hang-cho-thanh-toan",
    icon: <Icon fontSize="small">account_balance_wallet</Icon>,
    route: "/bao-cao/hang-cho-thanh-toan",
    component: <HangChoThanhToan />,
    noCollapse: true,
    roles: VAI_TRO_HANG_CHO_THANH_TOAN,
  },
  { type: "divider", key: "divider-quan-ly", roles: VAI_TRO_HEADER_QUAN_LY },
  { type: "title", title: "Quản lý", key: "title-quan-ly", roles: VAI_TRO_HEADER_QUAN_LY },
  {
    type: "collapse",
    name: "Chủ vườn / Vườn",
    key: "quan-ly-chu-vuon-vuon",
    icon: <Icon fontSize="small">groups</Icon>,
    route: "/quan-ly/chu-vuon-vuon",
    component: <QuanLyChuVuonVuon />,
    noCollapse: true,
    roles: VAI_TRO_QUAN_LY,
  },
  {
    type: "collapse",
    name: "Hợp tác xã",
    key: "quan-ly-hop-tac-xa",
    icon: <Icon fontSize="small">apartment</Icon>,
    route: "/quan-ly/hop-tac-xa",
    component: <QuanLyHopTacXa />,
    noCollapse: true,
    roles: VAI_TRO_QUAN_LY,
  },
  {
    type: "collapse",
    name: "Sọt",
    key: "quan-ly-sot",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/quan-ly/sot",
    component: <QuanLySot />,
    noCollapse: true,
    roles: VAI_TRO_QUAN_LY,
  },
  {
    type: "collapse",
    name: "Danh mục",
    key: "quan-ly-danh-muc",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/quan-ly/danh-muc",
    component: <DanhMuc />,
    noCollapse: true,
    roles: VAI_TRO_QUAN_LY,
  },
  {
    type: "collapse",
    name: "Loại bơ & Giá",
    key: "quan-ly-gia-theo-ngay",
    icon: <Icon fontSize="small">sell</Icon>,
    route: "/quan-ly/gia-theo-ngay",
    component: <GiaTheoNgay />,
    noCollapse: true,
    roles: VAI_TRO_DANH_MUC_GIA,
  },
  {
    type: "collapse",
    name: "Tài khoản",
    key: "quan-ly-tai-khoan",
    icon: <Icon fontSize="small">manage_accounts</Icon>,
    route: "/quan-ly/tai-khoan",
    component: <QuanLyTaiKhoan />,
    noCollapse: true,
    roles: VAI_TRO_QUAN_LY,
  },
  {
    type: "collapse",
    name: "Cài đặt",
    key: "cai-dat",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/quan-ly/cai-dat",
    component: <CaiDat />,
    noCollapse: true,
    roles: VAI_TRO_QUAN_LY,
  },
];

// Route thuộc luồng thao tác (không hiện trên Sidenav) nhưng vẫn cần đăng ký với router.
const hiddenRoutes = [
  {
    key: "ho-so",
    name: "Hồ sơ của tôi",
    route: "/ho-so",
    component: <HoSo />,
  },
  // Tạm tắt — bật lại khi BAT_HUONG_DAN = true (lib/batHuongDan.js)
  ...(BAT_HUONG_DAN
    ? [
        {
          key: "huong-dan",
          name: "Hướng dẫn sử dụng",
          route: "/huong-dan",
          component: <HuongDan />,
        },
      ]
    : []),
  {
    key: "thu-mua-chon-vuon",
    name: "Chọn vườn",
    route: "/thu-mua/:maChuVuon/vuon",
    component: <ChonVuon />,
    roles: VAI_TRO_THU_MUA,
  },
  {
    key: "thu-mua-nhap",
    name: "Nhập thu mua",
    route: "/thu-mua/:maChuVuon/:maVuon/nhap",
    component: <FormThuMua />,
    roles: VAI_TRO_THU_MUA,
  },
  {
    key: "thu-mua-xac-nhan-thanh-toan",
    name: "Gửi về kế toán",
    route: "/thu-mua/xac-nhan/:id",
    component: <XacNhanThanhToan />,
    roles: VAI_TRO_THU_MUA,
  },
  {
    key: "hang-cho-thanh-toan-chi-tiet",
    name: "Xử lý thanh toán",
    route: "/bao-cao/hang-cho-thanh-toan/phieu/:id",
    component: <ChiTietHangChoThanhToan />,
    roles: VAI_TRO_HANG_CHO_THANH_TOAN,
  },
  {
    key: "sot-chi-tiet",
    name: "Chi tiết Sọt",
    route: "/sot/:id",
    component: <ChiTietSot />,
    roles: VAI_TRO_THU_MUA,
  },
  {
    key: "chu-vuon-chi-tiet",
    name: "Lịch sử giao dịch",
    route: "/chu-vuon/:id",
    component: <ChiTietChuVuon />,
    // Chi tiết 1 chủ (sau quét / link) — không phải list-all QL.
    roles: VAI_TRO_CHU_VUON_VUON,
  },
];

export { sidebarRoutes, hiddenRoutes };
export default sidebarRoutes;
